// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import FullPageImage from "components/DigiHapi/FullPageImage";

export default function MaintenancePage() {
	return (
		<FullPageImage
			bgImage="maintenance"
			child={
				<MDBox component="section">
					<MDTypography variant="h3" textAlign="center" sx={{ color: "red" }}>
						{"Veuillez nous excuser !"}
					</MDTypography>
					<MDTypography variant="h3" textAlign="center" sx={{ color: "red" }}>
						{"Le serveur est en maintenance !"}
					</MDTypography>
				</MDBox>
			}
		/>
	);
}
